import styled from 'styled-components';
import config from '../assets/config';

export const Container = styled.div`
  background: ${config.theme.blueBackground};
  min-height: 100vh;
  padding-bottom: 30px;
`;
